module.exports = __webpack_public_path__ + "static/img/n1.b7bf9ba.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/n1.jpeg
// module id = 8MtY
// module chunks = 1